import {
  ResourceTrackingCode,
  CreateResourceTrackingCodeResponse,
} from 'models/ResourceTrackingCode'

import { api } from '../api'

export const resourceTrackingCodesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createResourceTrackingCode: builder.mutation<
      CreateResourceTrackingCodeResponse,
      {
        createResourceTrackingCodeRequest: ResourceTrackingCode & {
          resourceId: string
          resourceType: string
        }
        transactionToken: string
      }
    >({
      query: ({ createResourceTrackingCodeRequest, transactionToken }) => ({
        method: 'POST',
        url: `/${createResourceTrackingCodeRequest.resourceType}/${createResourceTrackingCodeRequest.resourceId}/source-tracking-codes`,
        body: createResourceTrackingCodeRequest,
        headers: {
          transaction_token: transactionToken,
        },
      }),
    }),
  }),
})

export const {
  useCreateResourceTrackingCodeMutation,
  endpoints: { createResourceTrackingCode },
} = resourceTrackingCodesApi
